/**
 * iter 144o - Mundalo brand assets, single source of truth.
 *
 * All three official logo PNGs live on Cloudinary under
 * `mundalo/brand/`. Use these constants in every <img>/<Image>/<source>
 * - never hard-code a URL or render the wordmark as styled italic text
 * any more.
 *
 * The source uploads are 1200×1200 with substantial blank padding around
 * the wordmark. We append Cloudinary's `e_trim` transformation so the
 * served file is cropped tight to the glyph; height-based CSS sizing
 * (e.g. `h-9 w-auto`) then yields the correct aspect ratio everywhere.
 *
 * Selection rules (per brand spec):
 *   • LIGHT background (cream / white) → BRAND_LOGO.black
 *   • DARK / deep ocean / hero overlay → BRAND_LOGO.white
 *   • MEMBER portal sidebar, ADMIN sidebar,
 *     marketing on light surfaces, PDF cover → BRAND_LOGO.green
 */
const BASE = 'https://res.cloudinary.com/des9fk8et/image/upload';
const TRIM = 'e_trim,f_auto,q_auto:good';

export const BRAND_LOGO = {
  white: `${BASE}/${TRIM}/mundalo/brand/mundalo-logo-white.png`,
  black: `${BASE}/${TRIM}/mundalo/brand/mundalo-logo-black.png`,
  green: `${BASE}/${TRIM}/mundalo/brand/mundalo-logo-green.png`,
};

export const BRAND_LOGO_ICON =
  `${BASE}/${TRIM}/mundalo/brand/mundalo-m-icon.png`;

// Convenience: pick the right logo for a given background lightness.
//   mode: 'dark' | 'light' | 'green' (primary brand color)
export function logoForBackground(mode) {
  if (mode === 'dark') return BRAND_LOGO.white;
  if (mode === 'green') return BRAND_LOGO.green;
  return BRAND_LOGO.black;
}
